import I18N from 'i18n-js';
const I18n = window.I18n || I18N;
I18n.translations || (I18n.translations = {});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
  "activerecord": {
    "attributes": {
      "data_entity": {
        "keys": {
          "address": "Address",
          "address_state": "State/Province",
          "appointments": "Appointment",
          "assigned_manager_id": "Assigned Recruiter",
          "attachments": "Attachment",
          "campaign_id": "Campaign",
          "completion_date": "Completed At",
          "country_short_code": "Country",
          "created_at": "Date added",
          "education": "Education",
          "email": "Email",
          "first_name": "First Name",
          "gender": "Gender",
          "geolocation": "Geolocation",
          "graduation_year": "Graduation Year",
          "labels": "Labels",
          "last_assigned_at": "Last Assigned Date",
          "last_interaction": "Last Interaction",
          "last_name": "Last Name",
          "location": "City/Municipality",
          "scheduled_at": "Scheduled At",
          "school_name": "School Name",
          "source": "Source",
          "talkscore_active_listening": "TalkScore Active Listening",
          "talkscore_answer_count": "TalkScore Answer Count",
          "talkscore_cefr": "TalkScore CEFR",
          "talkscore_comprehension": "TalkScore Comprehension / Spoken English Understanding",
          "talkscore_fluency": "TalkScore Fluency",
          "talkscore_generated_at": "Talkscore Generated at",
          "talkscore_grammar": "TalkScore Grammar",
          "talkscore_overall": "TalkScore Overall",
          "talkscore_pronunciation": "TalkScore Pronunciation",
          "talkscore_question_count": "TalkScore Question Count",
          "talkscore_scored_count": "TalkScore Scored Count",
          "talkscore_vocab": "TalkScore Vocabulary",
          "user_country_code": "Phone Country Code",
          "user_phone_number": "Mobile",
          "years_of_exp": "Years of Working Experience"
        }
      },
      "document/tag": {
        "permission": {
          "assigned_manager": "Onboarding Admin Access",
          "owner": "Owner Admin Access",
          "public": "Full Access"
        }
      },
      "smart_call/setting": {
        "scenario": {
          "custom_calls": "Custom Calls",
          "document_request": "Document Request",
          "engagement_calls_for_passive_candidates": "Engagement Calls for Passive Candidates",
          "feedback_collection": "Feedback Collection",
          "interview": "Interview",
          "job_fair_and_event_invitation": "Job Fair and Event Invitation",
          "offer_extension": "Offer Extension",
          "on_site_interview_invitation": "On Site Interview Invitation",
          "onboarding_information": "Onboarding Information",
          "rejection_notification": "Rejection Notification",
          "reminder": "Reminder",
          "status_update": "Status Update"
        }
      }
    },
    "models": {
      "candidate/attribute": "Candidate Attribute",
      "workflow": "Autoflow"
    }
  },
  "autoflow": {
    "add": "Add",
    "next": "Next",
    "operators": {
      "or": "OR"
    }
  },
  "campaign-settings": {
    "sourcing": {
      "facebook_job": {
        "save_success": "Facebook Job saved successfully"
      },
      "google": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Google Jobs saved successfully"
      },
      "landing_page": {
        "add_url": "Add a URL",
        "cancel": "Cancel",
        "custom_landing_page_description": "Generate new URLs and assign a source name per URL. Candidates who complete pre-screening on the URL will be tracked with your customized source name. Common source names are site name and assigned recruiter name, event name.",
        "custom_landing_page_title": "Customize the Landing Page Source",
        "custom_source_label": "Source Name",
        "date_created": "Date Created",
        "invalid_url": "Invalid Redirect URL",
        "landing_pages": "Landing Pages",
        "landing_pages_desc": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "redirect_after": "Redirect After",
        "redirect_url": "Redirect URL",
        "refresh_rate_min_error": "Refresh Rate must be at least 1 second",
        "reload_redirect": "Redirect/Reload",
        "save_success": "Landing page saved successfully",
        "seconds": "Seconds",
        "source_placeholder": "Ex. Washington Site",
        "source_title": "Track a custom source",
        "url_copy": "URL copied to clipboard"
      },
      "messenger": {
        "copy_url": "Copy URL",
        "create_messenger_source_url": "Create URL",
        "create_messenger_source_url_success": "Messenger URL was created successfully",
        "default_input_source_value": "Source",
        "default_select_option_value": "Select...",
        "facebook_pages": "Facebook Pages",
        "messenger_link": "Messenger Link",
        "messenger_source_url_description": "Leads that use this Messenger URL will be tracked with this source.",
        "messenger_source_url_title": "Track a custom source in Messenger URL",
        "page_title": "Facebook Page",
        "previously_created_messenger_urls": "Previously created Messenger URLs",
        "previously_created_messenger_urls_description": "Here are all the previously created Messenger URLs for this campaign.",
        "select_pages": "Select the Facebook Pages to list this campaign on Messenger, then click Save to apply your changes",
        "source_label": "Source",
        "source_title": "Track a custom source"
      },
      "tecoloco_jobs": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Tecoloco Jobs saved successfully"
      }
    }
  },
  "campaigns": {
    "edit": {
      "campaign_types": {
        "all": "All Campaigns"
      },
      "form": {
        "job_type": "Job type",
        "job_type_options": {
          "contract": "Contract",
          "fixed_term": "Fixed Term",
          "full_time": "Full time",
          "internship": "Internship",
          "part_time": "Part time",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "Volunteer"
        },
        "location": "Location",
        "salary": "Salary"
      }
    },
    "folders": {
      "all": "All Folders",
      "completed": {
        "title": "Completed"
      },
      "hired": {
        "title": "Hired"
      },
      "no_response": {
        "title": "No Response"
      },
      "on_hold": {
        "title": "On Hold"
      },
      "pending": {
        "title": "Inbox"
      },
      "rejected": {
        "title": "Rejected"
      },
      "shortlisted": {
        "title": "Shortlisted"
      }
    }
  },
  "chat": {
    "bulk": {
      "actions": {
        "share": {
          "title": "Share"
        }
      }
    },
    "buttons": {
      "proceed": "Proceed",
      "submit": "Submit"
    },
    "filters": {
      "search_campaigns": "Search campaigns"
    },
    "labels": {
      "no_results": "No Data Available"
    },
    "modals": {
      "confirm_your_action": "Confirm your action",
      "continue": "Continue"
    },
    "notice": {
      "candidate": {
        "one": "candidate",
        "other": "candidates"
      }
    },
    "options": {
      "deleted": "Deleted",
      "email": "EMAIL",
      "facebook": "FACEBOOK",
      "whatsapp": "WHATS APP"
    },
    "toastr": {
      "actions": {
        "background": "This action is being processed in the background.",
        "failed": "This action was not successfully processed.",
        "success": "This action was processed successfully."
      }
    },
    "upload": "Upload"
  },
  "companies": {
    "settings": {
      "buttons": {
        "delete": "Delete"
      },
      "folder_settings": {
        "destroy": {
          "confirm": "You are about to delete %{folder}. After deleting, it will no longer be visible in the campaigns. Do you wish to proceed?",
          "success": "The folder was deleted successfully"
        }
      },
      "team": {
        "role_permissions": {
          "manager": "Manager"
        }
      }
    }
  },
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about 1 hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about 1 month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about 1 year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost 1 year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than 1 second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over 1 year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "1 day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "1 month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "1 second",
        "other": "less than %{count} seconds"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Seconds",
      "year": "Year"
    }
  },
  "eos": {
    "campaign": {
      "applicant_scoring": {
        "applicant_scoring": {
          "add": "Add",
          "candidate_attribute": "Candidate Attribute",
          "description": "Select Candidate Attributes and assign a weight percentage to each one for a total ot 100% for the Applicant Score or this Campaign.",
          "dropdown_hint": "Select an Attribute from the list",
          "title": "Job Matching",
          "weight": "Weight"
        },
        "description": "Configure a Scoring System for this Campaign by assigning a weight to a Candidate Attribute (Geolocation, TalkScore English Proficiency and Multiple Choice Questions) and then setting up the scores for each item.",
        "error": "Job Matching was not saved. Please try again.",
        "item_scoring": {
          "candidate_attribute": "Candidate Attribute",
          "description": "Set up a score parameter to each of the items from 0 to 100%. In this case, a 100% means that a candidate with that particular parameter will get the full score allocated in the Job Matching tab",
          "empty": "No Candidate Attributes have been set up yet. Add Candidate Attributes and assign a weight to them first in the Job Matching tab",
          "hint": {
            "geolocation": "Distance from Campaign Location as set in the Campaign Main Settings",
            "multiple": "To edit these Items. Edit the options for this question in the Question tabs.",
            "talkScore": ""
          },
          "items": "Items and Score Parameters",
          "title": "Item Scoring",
          "value_label": {
            "geopoint": "Within"
          }
        },
        "shared": {
          "cancel": "Cancel",
          "candidate": "Candidate Attribute",
          "save": "Save"
        },
        "success": "Job Matching was saved successfully.",
        "title": "Job Matching",
        "weight_error": "Weight distribution has to add up 100%"
      },
      "label": {
        "actions": {
          "activate": {
            "body": "Are you sure you want to activate this campaign?",
            "title": "Activate Campaign"
          },
          "archive": {
            "body": "Are you sure you want to archive this campaign?",
            "title": "Archive Campaign"
          },
          "bulk_archive": {
            "body": "Are you sure you want to archive these campaigns?",
            "title": "Archive Campaigns"
          },
          "close": {
            "body": "Are you sure you want to stop applications for this campaign?",
            "title": "Stop applications"
          },
          "duplicate": {
            "body": "Are you sure you want to duplicate this campaign?",
            "title": "Duplicate Campaign"
          },
          "export": {
            "body": "Are you sure you want to export this campaign?",
            "title": "Export Campaign"
          },
          "favorite": {
            "body": "Are you sure you want to add this campaign to favorites?",
            "title": "Add to favorites"
          },
          "open": {
            "body": "Are you sure you want to allow applications for this campaign?",
            "title": "Allow applications"
          },
          "unfavorite": {
            "body": "Are you sure you want to remove this campaign from favorites?",
            "title": "Remove from favorites"
          }
        },
        "add_button": "Add a Button",
        "add_candidates": "Add candidates",
        "add_question_set": "Add a Question Set",
        "autoflow": "Autoflow",
        "banner": "Banner",
        "call_to_action": "Call to Action",
        "campaign_types": {
          "exit_interview": "Exit Interview",
          "inquiry": "Inquiry",
          "job_application": "Job Application",
          "job_template": "Template",
          "onboarding": "Onboarding",
          "single_time_engagement": "Broadcast",
          "unassigned": "Unassigned"
        },
        "cancel": "Cancel",
        "candidates": "Candidates",
        "categories": {
          "active": "Active",
          "archived": "Archived",
          "closed": "Closed"
        },
        "clear_filters": "Clear filters",
        "clear_selection": "Clear selection",
        "closed_campaigns": "Closed campaigns",
        "completion_message": "Completion Message",
        "copy": "Copy",
        "create_button": "Create Button",
        "created_at": "Created at",
        "created_at_by": "Created at %{date} by %{user}",
        "crop": "Crop",
        "expected_csv_columns": "Expected CSV columns",
        "explore_leads": "Explore leads",
        "facebook_pixel_id": "Facebook Pixel ID",
        "favorite": "Favorite",
        "favorites": "Favorites",
        "google_tag_container_id": "Google Tag Manager Container ID",
        "job_category": "Job category",
        "job_matching": "Job matching",
        "job_profile": "Job profile",
        "landing_page_type": "Landing Page Type",
        "landing_page_url": "Landing Page URL",
        "last_activity": {
          "custom": "Custom",
          "last_30_days": "Last 30 days",
          "last_7_days": "Last 7 days",
          "last_90_days": "Last 90 days",
          "title": "Last activity",
          "today": "Today"
        },
        "main_settings": "Main settings",
        "new_landing_page_design": "New Landing Page design",
        "onboarding_questions": "Onboarding questions",
        "prescreening_questions": "Prescreening Questions",
        "published_on": "Published on",
        "redirect_url": "Redirect URL",
        "see_all": "See all",
        "select_all_campaigns_count": "Select all %{count} campaigns",
        "select_multiple_campaigns": "Select multiple campaigns",
        "selected_all_current_filters": "Selected all %{count} campaigns with current filters",
        "showing_all_results": "Showing all %{count} results",
        "text_displayed": "Text displayed",
        "unfavorite": "Unfavorite"
      },
      "talkscore": {
        "weight_distribution": {
          "description": "Set up a Weight Distribution per TalkScore parameter  from 0 to 100% for this campaign. This weight Distribution will be used to calculate the Overall Score of the application and for the Job Matching System.",
          "error": "TalkScore Settings were not saved. Please try again.",
          "subtitle": "Score Parameters",
          "success": "TalkScore Settings were saved successfully.",
          "title": "TalkScore Settings"
        }
      },
      "text": {
        "active_cta_limit": "Active button count limit reached.",
        "add_cta": "Add Call to Action buttons to the Completion Screen",
        "add_cta_info": "Call to Action buttons on Landing Page completion screens to redirect applicants to your socials or to perform an action. You can create multiple buttons, but only three can be active at a time.",
        "allowed_banner_files": "Allowed file types: jpg, png, jpeg. Max %{file_size}.",
        "apply_new_design": "Apply the new landing page design to this campaign.",
        "banner_notice": "You are using the default banner for all your campaigns from Company Settings.",
        "banner_required": "Banner is required.",
        "button_limit_reached": "Button count hard limit reached",
        "click_on_dropdown": "Click on dropdown to read more about each type.",
        "closed_campaigns_desc": "This is a new category that groups campaigns where the \"Allow new application\" option is disabled",
        "custom_source_guide": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "default_banner_use": "If no banner is added and a Default Banner is available in Company Settings, the Default Banner will be used.",
        "delete_set_confirmation": "Are you sure you want to remove this question set from this campaign?",
        "incomplete_details": "Incomplete details",
        "internal_server_error": "Sorry, we are experiencing an internal server problem. Please try again later.",
        "invalid_url": "%{url} is not a valid URL",
        "landing_page_type": {
          "multiple": {
            "description": "Questions are displayed one screen at a time.",
            "title": "One Question Per Screen"
          },
          "single": {
            "description": "All questions are displayed on a single page.",
            "title": "Long Form"
          }
        },
        "landing_pages": "Landing Pages",
        "no_campaigns_found": "No campaigns found",
        "nothing_to_update": "Nothing to update.",
        "page_type_notice": "You have already selected a %{type} type for all your campaigns from Company Settings.",
        "question_set_consistency": "By using a Question Set, you can ensure consistency across multiple Campaigns. To edit them, go to the Question Set tab in Templates.",
        "recommended_banner": "%{width}px x %{height}px recommended.",
        "response_resubmit": {
          "disabled": "Disable the back button to prevent resubmissions (Not applicable to Onboarding campaigns)",
          "enabled": "Enable the back button to allow resubmissions (Not applicable to Onboarding campaigns)"
        },
        "search_campaigns_by": "Search campaigns by name, job title, or keyword (e.g., 'Sales Associate')",
        "select_multiple_campaigns": {
          "desc1": "This option allows user to filter Leads by using the multiple selection in this view",
          "desc2": "Other options like \"Stop new applications\" could be added as options for multiple campaigns"
        },
        "select_question_set": "Select a Question Set to add",
        "selected_number_campaigns": "Selected %{count} campaigns",
        "shown_end_form": "Shown at the end of the form.",
        "updated_successfully": "Updated successfully.",
        "view_selected_set_info": "View the Selected Question Set, remove it from this Campaign or replace it by another existing set. To edit the questions directly, go to the Question Set Templates tab."
      }
    },
    "candidate": {
      "application": {
        "id": "Application ID",
        "talkscore": {
          "active_listening": {
            "A0": "Difficulty in understanding spoken English, frequently requiring repetition and rephrasing; struggles significantly with unscripted speech.",
            "A1": "Difficulty in understanding spoken English, frequently requiring repetition and rephrasing; struggles significantly with unscripted speech.",
            "A1+": "Difficulty in understanding spoken English, frequently requiring repetition and rephrasing; struggles significantly with unscripted speech.",
            "A2": "Can understand basic spoken English, particularly in familiar situations, though may miss nuances and implied meanings.",
            "A2+": "Can understand basic spoken English, particularly in familiar situations, though may miss nuances and implied meanings.",
            "B1": "Understands main points of clear standard speech on familiar matters; may require occasional clarification in noisy backgrounds or with idiomatic language.",
            "B1+": "Understands main points of clear standard speech on familiar matters; may require occasional clarification in noisy backgrounds or with idiomatic language.",
            "B2": "Can follow extended speech and complex lines of argument provided the topic is reasonably familiar; may miss some subtleties and cultural references.",
            "B2+": "Can follow extended speech and complex lines of argument provided the topic is reasonably familiar; may miss some subtleties and cultural references.",
            "C1": "Exhibits excellent understanding of spoken language even when involving abstract, structurally complex or highly idiomatic speech.",
            "C1+": "Exhibits excellent understanding of spoken language even when involving abstract, structurally complex or highly idiomatic speech.",
            "C2": "Exhibits excellent understanding of spoken language even when involving abstract, structurally complex or highly idiomatic speech."
          },
          "breakdown": "Score Breakdown",
          "categories": {
            "active_listening": "Active Listening",
            "comprehension": "Comprehension",
            "fluency": "Fluency",
            "grammar": "Grammar",
            "pronunciation": "Pronunciation",
            "vocab": "Vocabulary"
          },
          "comprehension": {
            "A0": "Comprehends only very basic spoken and written English with significant difficulties in understanding sentences.",
            "A1": "Comprehends only very basic spoken and written English with significant difficulties in understanding sentences.",
            "A1+": "Comprehends only very basic spoken and written English with significant difficulties in understanding sentences.",
            "A2": "Can understand phrases and the highest frequency vocabulary related to areas of most immediate personal relevance; struggles with complex texts and speech.",
            "A2+": "Can understand phrases and the highest frequency vocabulary related to areas of most immediate personal relevance; struggles with complex texts and speech.",
            "B1": "Can understand the main points of clear standard input on familiar matters; may have trouble with complex or abstract content.",
            "B1+": "Can understand the main points of clear standard input on familiar matters; may have trouble with complex or abstract content.",
            "B2": "Understands detailed reasoning in both spoken and written language, including technical discussions in their specialization, though may struggle with highly abstract or culturally loaded texts.",
            "B2+": "Understands detailed reasoning in both spoken and written language, including technical discussions in their specialization, though may struggle with highly abstract or culturally loaded texts.",
            "C1": "Fully understands almost everything heard or read with ease, including indirect, figurative, and implied meanings.",
            "C1+": "Fully understands almost everything heard or read with ease, including indirect, figurative, and implied meanings.",
            "C2": "Fully understands almost everything heard or read with ease, including indirect, figurative, and implied meanings."
          },
          "error": {
            "subtitle": "Please refresh the page or try again later",
            "title": "Oops! Something went wrong while loading this report."
          },
          "fluency": {
            "A0": "Speech is very slow and often halted by searches for expressions and formulations, leading to disjointed communication.",
            "A1": "Speech is very slow and often halted by searches for expressions and formulations, leading to disjointed communication.",
            "A1+": "Speech is very slow and often halted by searches for expressions and formulations, leading to disjointed communication.",
            "A2": "Can manage simple, rehearsed speech but struggles to speak spontaneously and connect ideas fluidly, resulting in frequent pauses.",
            "A2+": "Can manage simple, rehearsed speech but struggles to speak spontaneously and connect ideas fluidly, resulting in frequent pauses.",
            "B1": "Shows moderate fluency, capable of maintaining a conversation despite some hesitation and uneven speech flow.",
            "B1+": "Shows moderate fluency, capable of maintaining a conversation despite some hesitation and uneven speech flow.",
            "B2": "Speech is generally fluent with only occasional repetition or self-correction; hesitation is usually content-related rather than to search for language.",
            "B2+": "Speech is generally fluent with only occasional repetition or self-correction; hesitation is usually content-related rather than to search for language.",
            "C1": "Speech is fluid and spontaneous with rare interruptions or hesitation, demonstrating effective command of idiomatic expressions and natural flow.",
            "C1+": "Speech is fluid and spontaneous with rare interruptions or hesitation, demonstrating effective command of idiomatic expressions and natural flow.",
            "C2": "Speech is fluid and spontaneous with rare interruptions or hesitation, demonstrating effective command of idiomatic expressions and natural flow."
          },
          "generated_on": "Generated on",
          "grammar": {
            "A0": "Grammar control is very limited; errors are pervasive and often obstruct understanding.",
            "A1": "Grammar control is very limited; errors are pervasive and often obstruct understanding.",
            "A1+": "Grammar control is very limited; errors are pervasive and often obstruct understanding.",
            "A2": "Shows some control over basic grammatical structures, though complex sentences are often error-prone, occasionally impeding meaning.",
            "A2+": "Shows some control over basic grammatical structures, though complex sentences are often error-prone, occasionally impeding meaning.",
            "B1": "Grammar is generally correct for familiar topics, though mistakes may occur in more complex structures or unfamiliar situations.",
            "B1+": "Grammar is generally correct for familiar topics, though mistakes may occur in more complex structures or unfamiliar situations.",
            "B2": "Good grammatical control; errors occur but do not typically affect meaning, and complex structures are handled with some confidence.",
            "B2+": "Good grammatical control; errors occur but do not typically affect meaning, and complex structures are handled with some confidence.",
            "C1": "Demonstrates strong grammatical control; errors are rare and minor, with a clear ability to use complex grammar forms naturally.",
            "C1+": "Demonstrates strong grammatical control; errors are rare and minor, with a clear ability to use complex grammar forms naturally.",
            "C2": "Demonstrates strong grammatical control; errors are rare and minor, with a clear ability to use complex grammar forms naturally."
          },
          "overall": {
            "A0": "This score range indicates minimal command of the English language. Candidates within this band demonstrate considerable difficulties in understanding and expressing basic English, limiting their ability for effective communication.",
            "A1": "This score range indicates minimal command of the English language. Candidates within this band demonstrate considerable difficulties in understanding and expressing basic English, limiting their ability for effective communication.",
            "A1+": "This score range indicates minimal command of the English language. Candidates within this band demonstrate considerable difficulties in understanding and expressing basic English, limiting their ability for effective communication.",
            "A2": "Candidates scoring in this range possess a limited command of the language. They are able to understand and communicate basic English in familiar situations, but their proficiency is not sufficient for complex or less familiar scenarios, limiting their ability for effective communication.",
            "A2+": "Candidates scoring in this range possess a limited command of the language. They are able to understand and communicate basic English in familiar situations, but their proficiency is not sufficient for complex or less familiar scenarios, limiting their ability for effective communication.",
            "B1": "This score range reflects a fair level of proficiency in English. Candidates can understand and discuss familiar subjects but might struggle with new subjects or fast speakers. Communication may be flawed by grammatical inaccuracies, fluency or pronunciation, which can affect communication but not limit it.",
            "B1+": "This score range reflects a fair level of proficiency in English. Candidates can understand and discuss familiar subjects but might struggle with new subjects or fast speakers. Communication may be flawed by grammatical inaccuracies, fluency or pronunciation, which can affect communication but not limit it.",
            "B2": "Candidates in this score range have a strong command of the English language. They can engage in extended discussions and understand detailed information. Although minor language errors might occur, they rarely reduce communication effectiveness.",
            "B2+": "Candidates in this score range have a strong command of the English language. They can engage in extended discussions and understand detailed information. Although minor language errors might occur, they rarely reduce communication effectiveness.",
            "C1": "This score range indicates a near native command of the English language. Candidates exhibit the ability to fluently and accurately understand and use complex language, adeptly handling advanced communication in any setting.",
            "C1+": "This score range indicates a near native command of the English language. Candidates exhibit the ability to fluently and accurately understand and use complex language, adeptly handling advanced communication in any setting.",
            "C2": "This score range indicates a near native command of the English language. Candidates exhibit the ability to fluently and accurately understand and use complex language, adeptly handling advanced communication in any setting."
          },
          "overall_score": "Overall Score",
          "pronunciation": {
            "A0": "Pronunciation is heavily influenced by candidates' first language, often making comprehension difficult without considerable effort from both the speaker and listener.",
            "A1": "Pronunciation is heavily influenced by candidates' first language, often making comprehension difficult without considerable effort from both the speaker and listener.",
            "A1+": "Pronunciation is heavily influenced by candidates' first language, often making comprehension difficult without considerable effort from both the speaker and listener.",
            "A2": "Pronunciation errors are still frequent and may limit understanding when both listening and speaking, but basic phrases and expressions can be generally comprehensible.",
            "A2+": "Pronunciation errors are still frequent and may limit understanding when both listening and speaking, but basic phrases and expressions can be generally comprehensible.",
            "B1": "This score range reflects a fair level of proficiency in English. Candidates can understand and discuss familiar subjects but might struggle with new subjects or fast speakers. Communication may be flawed by grammatical inaccuracies, fluency or pronunciation, which can affect communication but not limit it.",
            "B1+": "This score range reflects a fair level of proficiency in English. Candidates can understand and discuss familiar subjects but might struggle with new subjects or fast speakers. Communication may be flawed by grammatical inaccuracies, fluency or pronunciation, which can affect communication but not limit it.",
            "B2": "Candidates pronounce most words correctly and are generally understood by native speakers, despite the occasional accent influence and mistakes.",
            "B2+": "Candidates pronounce most words correctly and are generally understood by native speakers, despite the occasional accent influence and mistakes.",
            "C1": "Pronunciation is clear and closely approximates that of a native speaker, allowing for smooth and effective communication.",
            "C1+": "Pronunciation is clear and closely approximates that of a native speaker, allowing for smooth and effective communication.",
            "C2": "Pronunciation is clear and closely approximates that of a native speaker, allowing for smooth and effective communication."
          },
          "questions": "Scored Questions",
          "reading": {
            "likely": {
              "description": "Voice analysis and speech-pattern data suggest the candidate was likely reading from a script. The assessment is designed to evaluate spoken fluency, so reading may impact their score. Please review a short segment of the recording and treat the results with caution.",
              "title": "Likely reading"
            },
            "suspected": {
              "description": "Some indications of reading were found (e.g., frequent micro-pauses or unusually precise articulation). The response still contains natural elements, but you may wish to review the recording before relying on the fluency score.",
              "title": "Suspected reading"
            }
          },
          "see_less": "See less",
          "see_more": "See more",
          "vocab": {
            "A0": "Vocabulary range is very limited, restricted, insufficient for basic conversations or conveying precise meaning.",
            "A1": "Vocabulary range is very limited, restricted, insufficient for basic conversations or conveying precise meaning.",
            "A1+": "Vocabulary range is very limited, restricted, insufficient for basic conversations or conveying precise meaning.",
            "A2": "Vocabulary is sufficient for basic conversations about familiar topics but lacks diversity and precision, limiting expression especially in unfamiliar contexts.",
            "A2+": "Vocabulary is sufficient for basic conversations about familiar topics but lacks diversity and precision, limiting expression especially in unfamiliar contexts.",
            "B1": "Candidates have a reasonable range of vocabulary for familiar topics and can sometimes paraphrase successfully when lacking specific vocabulary.",
            "B1+": "Candidates have a reasonable range of vocabulary for familiar topics and can sometimes paraphrase successfully when lacking specific vocabulary.",
            "B2": "Vocabulary range is broad enough to discuss a variety of topics with some detailed expressions; occasional inaccuracies do not hinder communication.",
            "B2+": "Vocabulary range is broad enough to discuss a variety of topics with some detailed expressions; occasional inaccuracies do not hinder communication.",
            "C1": "Vocabulary is extensive and nuanced, allowing candidates to express complex and subtle ideas effectively and accurately.",
            "C1+": "Vocabulary is extensive and nuanced, allowing candidates to express complex and subtle ideas effectively and accurately.",
            "C2": "Vocabulary is extensive and nuanced, allowing candidates to express complex and subtle ideas effectively and accurately."
          }
        }
      }
    },
    "company": {
      "label": {
        "color_theme": "Color theme",
        "default_banner": "Default Banner",
        "landing_page_sop_up_screen": "Landing Page Pop-up Screen",
        "primary": "Primary",
        "secondary": "Secondary",
        "shade": "Shade"
      },
      "listings": {
        "button": {
          "cancel": "Cancel",
          "save": "Save",
          "upload": "Upload"
        },
        "description": "This page is where your selected job application campaigns are displayed, letting candidates view your job openings and apply through their respective Landing Pages",
        "input": {
          "label": {
            "banner": "Banner",
            "banner_allowed_types": "Allowed file types: jpg, jpeg and png.",
            "banner_recommended_size": "1280px x 400px",
            "copied": "Copied to Clipboard",
            "header_char_count": "%{count}/60 characters",
            "listings_url": "Job Listing Page URL",
            "page_header": "Page Header"
          },
          "placeholder": {
            "page_header": "Search Job Openings at %{company}"
          }
        },
        "messages": {
          "error": "Settings were not saved. Please try again.",
          "success": "Settings were saved successfully."
        },
        "page": {
          "button": {
            "apply": "Apply",
            "first": "First",
            "last": "Last",
            "search": "SEARCH"
          },
          "input": {
            "keywords": "Keywords",
            "location": "Location",
            "remote": "Remote"
          },
          "label": {
            "default_header": "Search Job Openings at %{company}",
            "go_to_top": "Go to the top",
            "job_count": "Displaying %{count} of %{total} jobs",
            "no_results": "No Results",
            "salary_undisclosed": "Undisclosed"
          },
          "source": "Job Listing Page"
        },
        "title": "Job Listing Page"
      },
      "text": {
        "apply_new_design": "Apply the new landing page design to all campaigns.",
        "apply_page_type": "Apply the Landing Page Type to all Campaigns. If selected, option will be disabled in Campaign Settings.",
        "default_banner": "If no banner is uploaded to a campaign, the Default Banner will be used.",
        "default_banner_use": "Use Default Banner across all campaigns. If selected, option will be disabled in Campaign Settings.",
        "enter_custom_color": "Alternatively, you can enter HEX code values in the Primary and Secondary text fields.",
        "landing_page_sop_up_screen": "This will be displayed as a pop-up in the Landing Pages before candidates input their information.",
        "select_color_palette": "Select colors for the Landing Page color theme using the palette and sliders below."
      }
    },
    "document": {
      "tag": {
        "edit": {
          "click_here": "Click here.",
          "click_here_url": "https://help.talkpush.com/en",
          "description": "Configure documents for recognition, ownership validation and data extraction to existing candidate attributes. Want to know more?",
          "error": "An error ocurred, please try again later",
          "success": "Document was successfully updated.",
          "title": "Edit Document"
        },
        "form": {
          "country": {
            "description": "Select which country issues the document.",
            "title": "Country of Issue"
          },
          "data_extraction": {
            "attribute": "Candidate Attribute",
            "data_point": "Data Point",
            "description": "Extract data points from document and save them in a candidate attribute.",
            "title": "Data Extraction"
          },
          "document_status": {
            "description": "All of the possible document statuses and what they mean.",
            "failed": {
              "description": "There was a processing error.",
              "title": "Failed"
            },
            "recognized": {
              "description": "Document type matches what was requested.",
              "title": "Recognized"
            },
            "title": "Document Status",
            "unrecognized": {
              "description": "Document type does not match what was requested or was unreadable.",
              "title": "Not Recognized"
            },
            "unverified": {
              "description": "Name does not match the candidate name or was unreadable.",
              "title": "Not Verified"
            },
            "verified": {
              "description": "Document type matches what was requested and name matches the candidate name.",
              "title": "Verified"
            }
          },
          "feedback": {
            "description": "Candidates receive real-time feedback on their recognition status. If active, candidates will be redirected to the Landing Page to submit their documents.",
            "title": "Real-time Recognition Feedback"
          },
          "identity_verification": {
            "description": "Validate if the name on the document belongs to the candidate.",
            "title": "Identity Verification"
          },
          "name": {
            "description": "This name is used to identify the document for recognition and data extraction.",
            "title": "Official Name of Document"
          },
          "permissions": {
            "assigned_manager": "Only Onboarding admins can view and download",
            "owner": "Owners can view and download documents",
            "public": "Anyone with Campaign access can view and download",
            "title": "Permissions"
          },
          "recognition": {
            "description": "Validate if the document type matches what was requested.",
            "title": "Document Recognition"
          }
        },
        "list": {
          "add": "Add Document",
          "description": "Manage the documents you would like to collect from candidates. Edit your existing documents or create new ones to begin extracting data from documents.",
          "identitiy_verification": {
            "configured": "Configured",
            "not_configured": "Not Configured"
          },
          "learn_more": "Learn More.",
          "learn_more_url": "https://help.talkpush.com/en",
          "no_results": "No Results",
          "search": "Search Document by Name or Country",
          "subtitle": "Document recognition and Data extraction",
          "table": {
            "data_extraction": "Data Extraction",
            "identity_verification": "Identity Verification",
            "name": "Document Name",
            "permissions": "Permissions"
          },
          "title": "Documents"
        },
        "new": {
          "error": "An error ocurred, please try again later",
          "success": "Document was successfully created.",
          "title": "New Document"
        }
      }
    },
    "email_preference": {
      "buttons": {
        "unsubscribe": "or unsubscribe me from all communications",
        "update": "Update My Email Preferences"
      },
      "checkboxes": {
        "application_updates": {
          "description": "Receive important updates about your job applications. Unsubscribe to stop receiving updates and remove all your data from our system.",
          "title": "Application Updates"
        },
        "new_opportunities": {
          "description": "Receive news about our company and invites to apply for new jobs.",
          "title": "New Opportunities & Job Fairs"
        }
      },
      "footer": {
        "note": "unsubscribing will delete all your information and remove your applications from our system"
      },
      "header": {
        "title": "Email Preferences for"
      },
      "not_found": {
        "notice": {
          "header": "Oops! We Couldn't Find Your Information",
          "message1": "It looks like we couldn't find your information in our system. This could happen if your email has already been unsubscribed or if your application has been removed.",
          "message2": "But don't worry! You can still stay in touch. If you're interested in new opportunities, please visit our <a class=\"job-listing-page-url\" target=\"_blank\" href=\"%{jobListingPage}\">Job Listing Page</a> to explore and apply for open positions."
        }
      },
      "notices": {
        "success": "Preferences Updated Successfully",
        "unsubscribe": {
          "error": "Something went wrong. Please try again.",
          "success": "You have been successfully unsubscribed from all communications."
        }
      },
      "unsubscribe_confirmation": {
        "notice": {
          "header": "You have been successfully unsubscribed from all communications.",
          "message": "We're sorry to see you go. If you change your mind in the future and are interested in new opportunities, please feel free to visit our <a class=\"job-listing-page-url\" target=\"_blank\" href=\"%{jobListingPage}\">Job Listing Page</a> to explore and apply for open positions."
        }
      }
    },
    "facebook_page": {
      "record": {
        "button": {
          "disconnect": "Disconnect",
          "login": "LOG IN WITH FACEBOOK",
          "renew": "Renew",
          "renew_all": "Renew All"
        },
        "label": {
          "actions": "Actions",
          "audit": {
            "disconnected": "Disconnected by %{user}",
            "last_renew": "Last Renewed by %{user}"
          },
          "auto_renew": {
            "one": "Auto renews in 1 day",
            "other": "Auto renews in %{count} days"
          },
          "confirmation": {
            "disconnect": {
              "text": "In order to reconnect a page after it has been disconnected, click on the Log in to Facebook button and follow the steps to re-authenticate it.",
              "title": "Disconnect Facebook Page"
            }
          },
          "create": {
            "error": "Error creating page(s). Please try again.",
            "success": "%{pages} successfully connected."
          },
          "description": "Manage your connected Facebook Pages or connect new ones to Talkpush. To connect new pages or reconnect one after an invalid token, click on Log in with Facebook and select the pages you wish to generate tokens for.",
          "disconnect": {
            "error": "Error updating %{page}. Please try again.",
            "success": "%{page} was successfully disconnected."
          },
          "facebook_id": "ID",
          "lead_ads_warning": {
            "contact": "or contact Product Support for assistance.",
            "learn_more": "Learn more here",
            "learn_more_url": "https://help.talkpush.com/en/articles/8892130-renew-or-disconnect-your-facebook-page-access-from-talkpush",
            "testing_tool": "Test your Lead Ads integration.",
            "text": "You will need to have the right level of access to correctly generate Access Tokens for Facebook Pages. Check the list of required permissions to make sure that the bots and Lead Ads integrations will function properly.",
            "title": "Warning"
          },
          "login": {
            "error": "Log In Error"
          },
          "name": "Name",
          "no_data": "No Data",
          "renew": {
            "error": "Error updating %{page}. Please try again.",
            "success": "The access token for %{page} was successfully renewed."
          },
          "required_permissions": "Required Permissions",
          "resubscribe": {
            "error": "Error updating. Please try again.",
            "success": "The access token for %{pages} successfully renewed."
          },
          "status": "Status",
          "title": "Facebook Page Access",
          "updatedAt": "Updated Date"
        },
        "modal": {
          "body": {
            "first_caption": "To reconnect them, you will have to log in with Facebook again and select them and any other page you wish to remain connected.",
            "second_caption_end": "or contact our Product Support team to guide you through this process.",
            "second_caption_link": "Learn more about the Access Tokens Dashboard",
            "second_caption_link_url": "https://help.talkpush.com/en/articles/8706222-facebook-access-token-dashboard",
            "second_caption_start": "Unsure how to proceed? →"
          },
          "button": {
            "continue": "Continue to Log in with Facebook"
          },
          "header": "Any Facebook Page previously connected will appear selected.",
          "warning": "By deselecting them, their tokens will be invalidated by Meta and the page will be disconnected."
        },
        "status": {
          "active": "Active",
          "expired": "Expired",
          "expiring_soon": "Expiring Soon",
          "invalid": "Invalid",
          "tooltip": {
            "active": "In order to use the dashboard features for this page, click on the Log in to Facebook button and follow the steps to re-authenticate it.",
            "expired": "This token has expired. Click on the Log in to Facebook button and follow the steps to re-authenticate it.",
            "invalid": "This token has been invalidated by Facebook due to an authentication issue. Click on the Log in to Facebook button and follow the steps to re-authenticate it."
          }
        }
      }
    },
    "folder": {
      "label": {
        "associated_campaigns": "Associated Campaigns",
        "create_custom_folder": "Create Custom Folder",
        "create_folder": "Create Folder",
        "delete_folder": "Delete Folder",
        "description": "Description",
        "edit_folder": "Edit %{title} Folder",
        "folder_name": "Folder Name",
        "select_folders": "Select Folders",
        "settings": "Folder Settings",
        "workflow": "Workflow"
      },
      "text": {
        "associate_to_campaigns": "Associate to all existing and new Campaigns",
        "associated_campaigns": {
          "one": "%{count} associated campaign",
          "other": "%{count} associated campaigns"
        },
        "candidates_can_move_to": "Candidates can be moved to",
        "cannot_dissaociate_with_candidates": "Campaigns that are currently associated and have candidates in the folder cannot be disassociated.",
        "settings_description": "Manage your Folders, create new ones and link them to campaigns, and determine which folder movements your users can do.",
        "text_counter": "%{count}/100 characters",
        "warn_has_candidates": {
          "one": "Warning: All candidates in %{folder} must be manually moved to another folder. There is still <1>count</1> candidate in this folder in the following campaign:",
          "other": "Warning: All candidates in %{folder} must be manually moved to another folder. There are still <1>count</1> candidates in this folder in the following campaign(s):"
        },
        "workflow_description": "Determine which folders candidates can be moved to by your users’ manual actions. <1>link</1>"
      }
    },
    "guest": {
      "label": {
        "add": "Add Guest",
        "create": {
          "desc": "Configure guests in order to easily share Candidate profiles with them via Email or WhatsApp",
          "error": "An error ocurred, please try again later",
          "required_value": "Add at least one communication method to reach this Guest in order to save.",
          "success": "Guest Created Successfully",
          "title": "Create Guest"
        },
        "name": "Name",
        "new": {
          "title": "New Guest"
        },
        "no_results": "No Results",
        "phone_number": "Phone Number",
        "role": "Role",
        "search": "Search Guests",
        "update": {
          "success": "Guest Updated Successfully",
          "title": "Update Guest"
        }
      }
    },
    "landing_page": {
      "apply_resume": {
        "modal": {
          "button": {
            "choose_file": "Choose File",
            "upload_again": "Upload Again"
          },
          "description": {
            "empty": "PDF, DOCX (max 10MB)",
            "failed": "Please try again",
            "invalid_file": "Please check that you sent the right document and that it is legible",
            "missing_contact_details": "Please update your resume and try again",
            "not_supported_file": "Please upload a PDF, DOCX file, 10MB max",
            "parsing": "We're analyzing your resume",
            "success": "Resume uploaded successfully",
            "uploading": "We're analyzing your resume"
          },
          "title": {
            "empty": "Upload your resume",
            "failed": "An error occurred while anlayzing your resume",
            "invalid_file": "Oops! This does not look like a resume",
            "missing_contact_details": "Oops! The uploaded resume is missing essential contact details",
            "not_supported_file": "File error",
            "parsing": "Uploading resume...",
            "success": "Resume uploaded successfully",
            "uploading": "Uploading resume..."
          }
        },
        "title": "Apply With Resume"
      },
      "communication_channels": {
        "email": "Email",
        "errors": {
          "field_required": "%{field} required."
        },
        "messenger": "Messenger",
        "sms": "SMS",
        "text": "Besides email, what is the best way to get hold of you and update you on the next steps?",
        "whatsapp": "WhatsApp"
      },
      "consent": "This site only uses session cookies which is essential to be able to navigate the site and use its features and functionalities. No personally identifiable data is collected by session cookies.",
      "label": {
        "audio": "Audio",
        "click_download": "Click here to download",
        "continue": "Continue",
        "contract": "Contract",
        "copy_it": "Copy it",
        "email": "Email",
        "email_it": "Email it",
        "error": "Error",
        "facebook": "Facebook",
        "file_upload": "File Upload",
        "first_name": "First Name",
        "fixed_term": "Fixed Term",
        "full_time": "Full time",
        "get_started": "Get Started",
        "internship": "Internship",
        "job_type": "Job Type",
        "last_name": "Last Name",
        "location": "Location",
        "new_recording": "New Recording",
        "next": "Next",
        "no_answer": "Not answered within time limit",
        "part_time": "Part time",
        "pause": "Pause",
        "phone_number": "Phone Number",
        "picture": "Picture",
        "play": "Play",
        "play_recording": "Play Recording",
        "post_it": "Post it",
        "probationary": "Probationary",
        "proceed": "Proceed",
        "project": "Project",
        "record_now": "Record Now",
        "regular": "Regular",
        "retake_picture": "Retake Picture",
        "retry": "Retry",
        "salary": "Salary",
        "save": "Save",
        "seasonal": "Seasonal",
        "share": "Share",
        "share_it": "Share it",
        "snap_photo": "Snap Photo",
        "start_camera": "Start Camera",
        "start_recording": "Start Recording",
        "stop": "Stop",
        "stop_recording": "Stop Recording",
        "submit": "Submit",
        "take_picture": "Take a picture",
        "text": "Text",
        "tweet_it": "Tweet it",
        "undisclosed": "Undisclosed",
        "upload": "Upload",
        "upload_again": "Upload Again",
        "upload_time": "Uploading video might take a while, please wait.",
        "view_open_positions": "View Open Positions",
        "view_sample": "View Sample",
        "volunteer": "Volunteer",
        "warning": "Warning",
        "whatsapp": "WhatsApp",
        "your_progress": "Your progress"
      },
      "notifications": {
        "prefilled_answers": {
          "linkedin": {
            "description": "We’ve used your LinkedIn profile to fill in some fields. Please review the information and update any sections that are missing or need adjustments.",
            "title": "Quick Start with LinkedIn"
          },
          "resume": {
            "description": "We’ve used your resume to fill in some fields. Please review the information and update any sections that are missing or need adjustments.",
            "title": "Quick Start with Resume"
          }
        }
      },
      "persistent_privacy_policy_link": {
        "click": "Click <a target=\"_b\" href=\"https://talkpush.com/privacy/\">here</a> to read their privacy policy.",
        "info": "We use a third-party service called Talkpush to help us collect the information we need to screen applicants and make recruitment decisions."
      },
      "text": {
        "about_company": "About %{company}",
        "about_our_company": "About our company",
        "application_invalid": "Invalid application",
        "camera_not_permitted": "Camera access is blocked.",
        "close_to_new_applications": "This job is no longer accepting applications. Click on the button below to view all open positions.",
        "close_warning": "In case of leaving this questionnaire before its completion, it can be completed on a later attempt, but no previously provided answer/record will be visible or editable.",
        "completion_message": "You have successfully completed and submitted your application for %{job}. Thank you!",
        "contact_channel": "What is the best way to contact me about my application?",
        "copied_succesfully": "Copied successfully",
        "dropdown_instruction": "Select an option",
        "expired_signature": {
          "check_email": "Please check your email for a new link",
          "close": "You can close this window",
          "description": "For your security, links expire after a certain time. We have already sent you a new link via email. Please open the latest email and click the new link provided to continue",
          "please_wait": "Please wait",
          "sub_description": "If you don't see the email shortly, please check you spam or junk folder",
          "title": "The link has expired"
        },
        "generic_browser_error": "Unable to record media. Make sure that there is an accessible media capture device and you are using the latest and modern browser for best experience.",
        "instructions": "Instruction(s): %{text}",
        "invalid_location": "Enter a valid location.",
        "job_type_options": {
          "contract": "Contract",
          "default": "Apply to know job type",
          "fixed_term": "Fixed Term",
          "full_time": "Full time",
          "internship": "Internship",
          "part_time": "Part time",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "Volunteer"
        },
        "mic_not_permitted": "Microphone access is blocked.",
        "min_max_char": "Entry should be %{min} character(s) minimum and %{max} characters maximum",
        "no_camera": "No camera available.",
        "no_media_device": "No accessible media device.",
        "no_mic": "No microphone available.",
        "no_supported_mimetype": "There are no supported MIME media type in this browser and recording quality might suffer. Try switching to another browser or device.",
        "not_supported_browser": {
          "text": "Click the three dot menu at the top right corner of the screen and open this link on your preferred browser to continue.",
          "title": "You won’t be able to complete this questionnaire in the Facebook browser."
        },
        "our_social_media": "Our Social Media",
        "play_media": {
          "answer": "played",
          "instruction": "Click play to begin, then click the 'next' button to move to the next question.",
          "local_storage_not_present": "Browser not supported"
        },
        "pop_up_privacy_policy": "By clicking Continue, you are agreeing to the <a href=\"%{policy_url}\">Privacy Policy</a> of %{company} and the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider. This will automatically check the box in the form.",
        "privacy_policy": "I agree to the <a target=\"_b\" href=\"%{policy_url}\">Privacy Policy</a> of %{company} and the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_talkpush": "I agree to the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_url": "https://talkpush.com/privacy/",
        "processing_answers": "Please give us a moment while we process your answers.",
        "question_progress": "%{current} of %{size}",
        "rate_your_experience": "Rate your experience",
        "receive_updates": "I want to receive updates through SMS, Facebook, Messenger or Whatsapp.",
        "remote_types": {
          "fully_remote": "Fully Remote",
          "temporarily_remote": "Temporarily Remote",
          "wfh_flexible": "WFH Flexible"
        },
        "salary_types": {
          "annually": "Annually",
          "biweekly": "Biweekly",
          "daily": "Daily",
          "hourly": "Hourly",
          "monthly": "Monthly",
          "one-time": "One-time",
          "weekly": "Weekly"
        },
        "share_with_network": "Share with your network",
        "size_of_mb": "%{size} of 20mb",
        "talkscore_instructions": "Recordings should have a minimum of %{min} seconds and a maximum of 1 minute. Make sure that the audio is clear and there is no background noise.",
        "talkscore_listen_and_repeat_instructions": "Recordings should have a maximum of 1 minute. Make sure that the audio is clear and there is no background noise.",
        "thank_you": "Thank you",
        "trouble_playing_response": "Having trouble playing this response?",
        "upload": {
          "error": {
            "failed": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, click Retry to process it again.",
              "title": "Oops! There was a problem while processing this document."
            },
            "max_retries": {
              "text": "You have reached the maximum number of retries for this document. Click next to continue to the next question or submit to finish this part of your process.",
              "title": "Oops! This does not look like the document we asked for."
            },
            "not_supported": "Some files cannot be uploaded",
            "partially_recognized": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, continue with the next question.",
              "title": "Make sure this is the document we asked for."
            },
            "recognition_error": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, click Retry to process it again.",
              "title": "Oops! There was a problem while processing this document."
            },
            "unrecognized": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, continue with the next question.",
              "title": "Oops! One of your documents does not look like the document we asked for."
            },
            "upload_error": {
              "text": "Please try again.",
              "title": "Oops! We encountered a problem while trying to upload your document."
            }
          },
          "file_invalid_type": "File format should be .jpg, .png .doc, .pdf, .xls.",
          "file_too_large": "The file size should be less than 10MB.",
          "status": {
            "failed": "Not Recognized",
            "partially_recognized": "Not Recognized",
            "processing": "Processing",
            "recognition_error": "Not Recognized",
            "recognized": "Recognized",
            "unrecognized": "Not Recognized",
            "upload_error": "Upload Error",
            "uploaded": "Uploaded"
          },
          "success": "Your document has been recognized. Click to continue with the next question."
        },
        "upload_failed": "There was an error while uploading your response. Please try again.",
        "video_limit": "The maximum video response length is 1 minute."
      }
    },
    "message": {
      "editor": {
        "controls": {
          "alignment": {
            "buttons": {
              "center": "Align Center",
              "left": "Alight Left",
              "right": "Align Right"
            }
          },
          "basic_format": {
            "bold": "Bold",
            "italic": "Italic",
            "underline": "Underline"
          },
          "call_to_action": {
            "buttons": {
              "add": "Add Button",
              "cancel": "Cancel",
              "edit": "Edit Button",
              "remove": "Remove Button",
              "save": "Save"
            },
            "labels": {
              "link": "Link",
              "text": "Text to display",
              "token": "Select a token from the list"
            },
            "link_types": {
              "link": "Link",
              "token": "Link Token"
            }
          },
          "emoji": {
            "labels": {
              "emoji": "Emoji"
            }
          },
          "font_size": {
            "buttons": {
              "add": "Font Size"
            }
          },
          "image": {
            "buttons": {
              "add": "Add"
            },
            "labels": {
              "image": "Image",
              "paste_image_url": "Paste Image URL"
            }
          },
          "link": {
            "buttons": {
              "add": "Add Link",
              "cancel": "Cancel",
              "edit": "Edit Link",
              "remove": "Remove Link",
              "save": "Save"
            },
            "labels": {
              "link": "Link",
              "text": "Text to display",
              "token": "Select a token from the list"
            },
            "link_types": {
              "link": "Link",
              "token": "Link Token"
            }
          },
          "token": {
            "buttons": {
              "tokens": "Tokens"
            }
          }
        }
      },
      "label": {
        "delete": "Delete",
        "duplicate": "Duplicate",
        "edit": "Edit"
      },
      "template": {
        "caption": "The Template Name will help you tell the templates apart, so make it unique and identifiable.",
        "character_count": "Character left: %{count} / %{limit}",
        "create_new": "Create New",
        "description": "Configure Message Templates for all channels to be used in Autoflow, for Bulk Actions, Folder Movements and as Quick Replies in all stages of the hiring process.",
        "email": {
          "name": "Email Template Name",
          "subject_line": "Subject Line",
          "tab": "Email",
          "title": "Email Templates"
        },
        "input": {
          "search_bar": {
            "placeholder": "Search Message Templates"
          }
        },
        "messenger": {
          "name": "Messenger Template Name",
          "tab": "Messenger",
          "title": "Messenger Templates"
        },
        "sms": {
          "name": "SMS Template Name",
          "tab": "SMS",
          "title": "SMS Templates"
        },
        "text": {
          "approved_by_meta": "Approved by Meta",
          "created_by_admin": "Created by Admin",
          "created_on": "Created on %{date} by %{name}",
          "last_edited_on": "Edited on %{date} by %{name}",
          "linked_campaigns_description": "This Message Template is being used for Autoflow in the following Campaigns",
          "update_from_template": "Update Message from Template",
          "update_from_template_confirmation": "This message is currently linked to a Message Template. If you edit it, it will be unlinked from the Template and any other changes will have to be done manually to this Autoflow action as any bulk edits to the Template will no longer be applied to it.",
          "update_template": "Update Message Template",
          "update_template_confirmation": "By updating this Message Template, all Autoflow actions using it will be updated as well. Do you want to proceed?"
        },
        "title": "Message Templates",
        "whatsapp": {
          "name": "WhatsApp Template Name",
          "tab": "WhatsApp",
          "title": "WhatsApp Templates"
        }
      },
      "tokens": {
        "aspiring_minds_assessment_link": {
          "description": "Personalized link to Aspiring Minds assessment",
          "title": "Aspiring Minds assessment link"
        },
        "aspiring_minds_login_link": {
          "description": "Personalized link to Aspiring Minds login",
          "title": "Aspiring Minds login link"
        },
        "aspiring_minds_password": {
          "description": "Aspiring Minds password",
          "title": "Aspiring Minds password"
        },
        "aspiring_minds_svar_url": {
          "description": "Personalized link to Aspiring Minds SVAR assessment",
          "title": "Aspiring Minds SVAR assessment link"
        },
        "aspiring_minds_username": {
          "description": "Aspiring Minds username",
          "title": "Aspiring Minds username"
        },
        "assigned_recruiter": {
          "description": "Full name of the assigned recruiter",
          "title": "Assigned Recruiter"
        },
        "assigned_recruiter_calendar_scheduler_url": {
          "description": "Link to the assigned manager's calendar scheduler",
          "title": "Assigned Recruiter Calendar Scheduler URL"
        },
        "button": {
          "name": "Tokens"
        },
        "calendar_date": {
          "description": "My Calendar appointment date",
          "title": "Calendar Date"
        },
        "calendar_time_end": {
          "description": "My Calendar appointment time end",
          "title": "Calendar Time End"
        },
        "calendar_time_start": {
          "description": "My Calendar appointment time start",
          "title": "Calendar Time Start"
        },
        "call_center_agent_assessment_url": {
          "description": "Personalized link to SHL Call Center Agent assessment",
          "title": "SHL Call Center Agent Assessment URL"
        },
        "call_center_agent_secondary_assessment_url": {
          "description": "Personalized link to SHL Call Center Agent Secondary assessment",
          "title": "SHL Call Center Agent Secondary Assessment URL"
        },
        "candidate_first_name": {
          "description": "Candidate's first name",
          "title": "Candidate First Name"
        },
        "candidate_id": {
          "description": "Candidate's application ID",
          "title": "Candidate ID"
        },
        "candidate_name": {
          "description": "Candidate's full name",
          "title": "Candidate Name"
        },
        "channel_optin_url": {
          "description": "Link to WhatsApp Opt-In page",
          "title": "WhatsApp Opt-in URL"
        },
        "chat_attachment": {
          "description": "Personalized chat ID to request files by Messenger",
          "title": "Chat Attachment"
        },
        "choose_position_link": {
          "description": "Personalized link to show job cards on Messenger",
          "title": "Choose Position Link"
        },
        "city": {
          "description": "Campaign's job location",
          "title": "Campaign City"
        },
        "company": {
          "description": "Name of your company",
          "title": "Company"
        },
        "emmersion_sign_in_url": {
          "description": "Sign In link to Emmersion assessments",
          "title": "Emmersion Link"
        },
        "harver_assessment_link": {
          "description": "Direct link to start or resume the assigned Harver assessment",
          "title": "Harver Assessment Link"
        },
        "hireiq_assessment_link": {
          "description": "Personalized link to Hire IQ assessment",
          "title": "Hire IQ Link"
        },
        "hireiq_pin": {
          "description": "Hire IQ PIN number",
          "title": "Hire IQ PIN"
        },
        "insert_picture": {
          "description": "Insert an image to be sent via email or Messenger",
          "title": "Insert Picture"
        },
        "insert_video": {
          "description": "Insert an video to be sent via email or Messenger",
          "title": "Insert Video"
        },
        "interview_page_url": {
          "description": "Personalized link to the landing page form",
          "title": "Interview Link"
        },
        "interview_url": {
          "description": "Personalized URL to the landing page form",
          "title": "Interview URL"
        },
        "job_landing_page_url": {
          "description": "Link to the job description page",
          "title": "Job Landing Page URL"
        },
        "job_title": {
          "description": "Job the candidate applied for",
          "title": "Job Title"
        },
        "mail_attachment": {
          "description": "Personalized email ID to request files by email",
          "title": "Mail Attachment"
        },
        "messenger_call_to_action_link": {
          "description": "Messenger Call To Action Link",
          "title": "Messenger Call To Action Link"
        },
        "messenger_interview_link": {
          "description": "Personalized link to trigger interview questions on Messenger",
          "title": "Messenger Interview Link"
        },
        "messenger_interview_url": {
          "description": "Personalized URL to trigger interview questions on Messenger",
          "title": "Messenger Interview URL"
        },
        "my_calendar_scheduler_url": {
          "description": "Link to your calendar scheduler",
          "title": "My Calendar Scheduler URL"
        },
        "onboarding_form_url": {
          "description": "Link to the onboarding online form",
          "title": "Onboarding Form URL"
        },
        "onboarding_link": {
          "description": "Link to the onboarding chatbot",
          "title": "Onboarding Link"
        },
        "pre_employment_chat_assessment_url": {
          "description": "Personalized link to SHL Chat assessment",
          "title": "SHL Pre Employment Chat Assessment URL"
        },
        "reapply_retention_period": {
          "description": "Campaign's cooling period",
          "title": "Re-apply Retention Period"
        },
        "recruiter_first_name": {
          "description": "First name of the assigned recruiter",
          "title": "Assigned Recruiter First Name"
        },
        "recruitment_center_scheduler_url": {
          "description": "Link to the campaign's recruitment center scheduler",
          "title": "Recruitment Center Scheduler URL"
        },
        "referee": {
          "description": "Name of the person who referred a candidate",
          "title": "Referree"
        },
        "rejected_reasons": {
          "description": "Reasons for rejecting the candidate",
          "title": "Rejection Reasons"
        },
        "sam_phone_call": {
          "description": "Link for the candidate to initiate a phone call with Sam",
          "title": "Sam Phone Call"
        },
        "sam_web_call": {
          "description": "Link for the candidate to initiate a web call with Sam",
          "title": "Sam Web Call"
        },
        "scheduled_at": {
          "description": "Candidate's scheduled date of interview",
          "title": "Scheduled at (Recruitment Center)"
        },
        "scheduled_at_recruiter_calendar": {
          "description": "Candidate's scheduled date of interview",
          "title": "Scheduled at (Recruiter Calendar)"
        },
        "scheduler_url": {
          "description": "Link to the campaign's recruitment center scheduler",
          "title": "Scheduler Link"
        },
        "shortlisted_reasons": {
          "description": "Reasons for shortlisting the candidate",
          "title": "Shortlisted Reasons"
        },
        "site_location": {
          "description": "Company site or branch where new hire will be assigned or trained",
          "title": "Site Location"
        },
        "svar_spoken_english_assessment_url": {
          "description": "Personalized link to SVAR Spoken English assessment",
          "title": "SVAR Spoken English Assessment URL"
        },
        "training_batch": {
          "description": "Batch or wave of trainees for onboarding",
          "title": "Training Batch"
        },
        "training_date": {
          "description": "Date of training as part of onboarding",
          "title": "Training Date"
        },
        "training_program": {
          "description": "Class or program of training for onboarding",
          "title": "Training Program"
        },
        "training_time": {
          "description": "Time of onboarding training",
          "title": "Training Time"
        },
        "training_venue": {
          "description": "Place of onboarding training",
          "title": "Training Venue"
        },
        "upcoming_scheduled_appointment": {
          "description": "Candidate's upcoming scheduled date of interview",
          "title": "Upcoming Scheduled Appointment"
        },
        "whatsapp_call_to_action_link": {
          "description": "Whatsapp To Action Link",
          "title": "Whatsapp Call To Action Link"
        },
        "workday_candidate_id": {
          "description": "Candidate ID from Workday",
          "title": "Workday Candidate ID"
        }
      }
    },
    "prompt": {
      "label": {
        "add_a_question": "Add a Question",
        "create_new": "Create New",
        "delete": "Delete",
        "question_set": {
          "name": "Question Set Name",
          "search": "Search Question Sets",
          "send": "Send Question Set"
        }
      },
      "text": {
        "created_by": "Created by %{name} on %{date}",
        "edited_by": "Edited by %{name} on %{date}",
        "question_set": {
          "cannot_be_deleted": "This Question Set cannot be deleted as it's being used by Autoflow in the following campaigns",
          "description": "Configure sets of questions from Question Templates to be used in Autoflow to trigger Follow up Question to Leads at any point of the process. ",
          "name_description": "This name will help you identify your Question Set when configuring an Autoflow. We recommend that you make it unique and easy to identify.",
          "title": "Question Sets",
          "used_in_campaigns": "This Question Set cannot be deleted as it's being used in the following Campaigns"
        }
      }
    },
    "smart_call": {
      "landing_page": {
        "label": {
          "agent": "%{agent} is about to call you",
          "from": "from %{number}",
          "get_ready": "Get Ready!",
          "greetings": "Hello %{name}",
          "retrigger": {
            "button": "Start the Interview Now",
            "title": "If the call doesn't start within 2 minutes, click the button below to trigger it manually"
          },
          "tips": {
            "heads_up": "📝 Be ready to talk about your experience and answer a few questions.",
            "place": "📞 Stay in a quiet place where you can focus without distractions.",
            "signal": "🌐 Ensure you have a strong phone signal for a smooth call.",
            "time": "⏰ Have at least 10 minutes available to complete the call.",
            "title": "Quick Tips"
          }
        }
      },
      "setting": {
        "add": "ADD new AI assistant",
        "create": {
          "action": "Integrate now",
          "click_here": "Click here",
          "click_here_url": "https://help.talkpush.com/en",
          "description": "Please enter the ID(s) of the Sam assistants you wish to integrate with Talkpush. You can find these IDs in your Sam platform account within the Sam detail view.",
          "error": "Oops! We couldn't recognize that ID. Please double-check and try once more.",
          "example": "e.g., S1R2wOIovQnibnzRk8hCF7w",
          "identifier": "Sam ID",
          "learn_more": "to learn how to find your Sam Assistant IDs",
          "title": "Enter Sam Assistant IDs"
        },
        "description": "Integrate AI Call Templates with Autoflow to automate calls, creating engaging call experiences that enhance every touchpoint with your talent.",
        "edit": {
          "form": {
            "candidate_attribute": "Select Candidate Attribute",
            "value": "Enter Value"
          },
          "input": {
            "description": "Complete the form below to configure your AI onboarding call. The information you provide will personalize the call and ensure all participants are well-informed",
            "title": "AI Call Configuration"
          },
          "language": "Language",
          "output": {
            "description": "Please map each piece of extracted information to the corresponding candidate attribute where it should be stored.",
            "title": "Map Extracted Data to Candidate Attributes"
          },
          "persona": "Persona",
          "sync": "CHECK FOR UPDATES",
          "sync_description": "Use this function to synchronize any changes made to your AI assistant on the original platform, such as updates to voice, language, scenarios, or data fields to collect.",
          "sync_modal": {
            "button": "SYNC NOW",
            "description": "Are you sure you want to synchronize the AI assistant with the latest updates from the original platform? This action will overwrite any changes made in Talkpush.",
            "title": "Sync AI Assistant"
          },
          "toaster": {
            "error": "Oops! Something went wrong. Please try again.",
            "sync": "AI assistant synchronized successfully.",
            "update": "AI call configuration updated successfully."
          }
        },
        "input": {
          "application_status": {
            "description": "Current status of the application.",
            "name": "Application Status"
          },
          "available_interview_dates": {
            "description": "List of dates available for interviews.",
            "name": "Available Interview Dates"
          },
          "available_interview_times": {
            "description": "List of times available for interviews.",
            "name": "Available Interview Times"
          },
          "benefits_info": {
            "description": "Summary of benefits offered.",
            "name": "Benefits Info"
          },
          "call_to_action": {
            "description": "Suggested next steps for the candidate.",
            "name": "Call to Action"
          },
          "company_updates": {
            "description": "Recent news or open positions.",
            "name": "Company Updates"
          },
          "contact_details": {
            "description": "How the candidate can reach out.",
            "name": "Contact Details"
          },
          "contact_email": {
            "description": "Email of the contact person.",
            "name": "Contact Email"
          },
          "contact_info": {
            "description": "Contact details for questions.",
            "name": "Contact Info"
          },
          "contact_person": {
            "description": "Name of the event contact.",
            "name": "Contact Person"
          },
          "contact_phone_number": {
            "description": "Phone number of the contact person.",
            "name": "Contact Phone Number"
          },
          "documents_required": {
            "description": "List of needed documents.",
            "name": "Documents Required"
          },
          "event_date": {
            "description": "Date of the event.",
            "name": "Event Date"
          },
          "event_description": {
            "description": "Brief details about the event.",
            "name": "Event Description"
          },
          "event_location": {
            "description": "Venue or access details.",
            "name": "Event Location"
          },
          "event_name": {
            "description": "Name of the event.",
            "name": "Event Name"
          },
          "event_reference": {
            "description": "The specific event or process to provide feedback on.",
            "name": "Event Reference"
          },
          "event_time": {
            "description": "Time of the event.",
            "name": "Event Time"
          },
          "feedback_provided": {
            "description": "Optional feedback for the candidate.",
            "name": "Feedback Provided"
          },
          "feedback_questions": {
            "description": "List of questions for feedback.",
            "name": "Feedback Questions"
          },
          "first_day_schedule": {
            "description": "Agenda for the first day.",
            "name": "First Day Schedule"
          },
          "future_opportunities_info": {
            "description": "Information about future openings.",
            "name": "Future Opportunities Info"
          },
          "incentive_details": {
            "description": "Information about any incentives (optional).",
            "name": "Incentive Details"
          },
          "information": {
            "description": "Any information that should be asked by Sam during the call.",
            "name": "Information"
          },
          "interview_location": {
            "description": "The address or venue where the interview will take place.",
            "name": "Interview Location"
          },
          "interview_questions": {
            "description": "List of questions to ask.",
            "name": "Interview Questions"
          },
          "interviewer_names": {
            "description": "Names of the interviewers.",
            "name": "Interviewer Names"
          },
          "next_steps": {
            "description": "What the candidate should expect next.",
            "name": "Next Steps"
          },
          "onboarding_location": {
            "description": "Venue for onboarding activities.",
            "name": "Onboarding Location"
          },
          "position_applied_for": {
            "description": "The job position the candidate applied for.",
            "name": "Position Applied For"
          },
          "position_title": {
            "description": "The title of the job position.",
            "name": "Position Title"
          },
          "purpose": {
            "description": "The personalized call goal.",
            "name": "Purpose"
          },
          "rejection_reason": {
            "description": "Optional reason for rejection.",
            "name": "Rejection Reason"
          },
          "special_instructions": {
            "description": "Additional information for the candidate.",
            "name": "Special Instructions"
          },
          "start_date": {
            "description": "Proposed start date for the position.",
            "name": "Start Date"
          },
          "start_time": {
            "description": "Additional information about the status.",
            "name": "Start Time"
          },
          "status_details": {
            "description": "Additional information about the status.",
            "name": "Status Details"
          },
          "submission_deadline": {
            "description": "Date by which documents should be submitted.",
            "name": "Submission Deadline"
          },
          "submission_method": {
            "description": "How to submit the documents.",
            "name": "Submission Method"
          }
        },
        "learn_more_url": "https://help.talkpush.com/en",
        "pending_configuration": "Pending Configuration",
        "scenario": {
          "custom_calls": "Tailored call types that you can customize to meet specific business needs, allowing for unique interactions that align with your recruitment strategies and company culture.",
          "document_request": "Calls requesting additional documents or information needed to advance their application, such as portfolios, certifications, or references, facilitating a complete evaluation.",
          "engagement_calls_for_passive_candidates": "Proactive calls aimed at nurturing relationships with passive candidates by informing them about new opportunities, company updates, or industry insights to keep them interested.",
          "feedback_collection": "Calls designed to gather feedback from candidates about their recruitment experience, providing valuable insights to improve your hiring process.",
          "interview": "Structured calls using predefined, consistent interview questions to efficiently assess candidate qualifications while ensuring fairness and compliance.",
          "job_fair_and_event_invitation": "Engaging calls that invite candidates to upcoming recruitment events, webinars, or job fairs, highlighting the benefits of attendance and encouraging participation.",
          "offer_extension": "Exciting calls to extend a job offer, outlining key details like salary, benefits, start date, and next steps, making the candidate feel valued and informed.",
          "on_site_interview_invitation": "Personalized calls inviting candidates to schedule an in-person interview, confirming appointment details, and providing essential logistical information to ensure a smooth experience.",
          "onboarding_information": "Informative calls providing new hires with essential onboarding details, including first-day instructions, required paperwork, and orientation schedules to ensure a seamless transition.",
          "rejection_notification": "Respectful calls to inform candidates that they were not selected, offering closure and potentially brief feedback to maintain a positive employer brand.",
          "reminder": "Automated calls reminding candidates of upcoming interviews, assessments, or deadlines for document submissions to keep the recruitment process on track.",
          "status_update": "Regular calls providing candidates with updates on their application status, ensuring they are informed about their progress and next steps in the recruitment process."
        },
        "subtitle": "Sam is a smart voice solution that talks to job candidates in real time.",
        "title": "Sam AI Calls"
      },
      "web_call": {
        "are_you_sure": "Are you sure?",
        "audio_help_access_denied": "Microphone access denied. Please check your browser settings.",
        "audio_help_access_granted": "Microphone access granted!",
        "audio_help_all_good": "✓ ALL GOOD",
        "audio_help_check_permissions": "<b>Check permissions</b> – click the lock in your address bar and allow mic & speaker access.",
        "audio_help_close_tabs": "<b>Close other tabs/apps</b> that might be using audio, then refresh this page.",
        "audio_help_give_access": "Give browser access to microphone",
        "audio_help_pick_device": "<b>Pick the right device</b> – turn the volume up and be sure nothing's muted.",
        "audio_help_play_sample": "Play a sample",
        "audio_help_play_test": "Play a test sound",
        "audio_help_quick_fixes": "Quick audio fixes",
        "audio_help_report_issue": "REPORT AN ISSUE",
        "audio_help_say_something": "Say something—watch the bar move",
        "audio_help_still_no_luck": "Still no luck? <a href=\"#\">Let us know and we will check right away.</a>",
        "audio_help_test_mic": "Test your mic",
        "audio_help_title": "We're having trouble with your sound",
        "call_duration": "Call Duration: %{seconds} seconds",
        "connecting": "Connecting...",
        "end_call": "END CALL",
        "end_call_warning": "If you hang up now, you won't be able to re-join this session.\n %{assistant} will finish the call on its own once the goal is reached.",
        "greeting": "HEY, %{name} 👋🏼",
        "i_need_help": "I need help",
        "instructions": "Click Start to meet %{assistant} in a virtual call, get your questions answered, and share details so we can move you to the next step.",
        "interview_already_completed": "This interview has already been completed. You cannot start a new session.",
        "listening": "LISTENING",
        "speaking": "SPEAKING",
        "start": "START",
        "stay_on_call": "STAY ON CALL",
        "thank_you_body": "Our team will review everything and get back to you soon with the next steps."
      }
    }
  },
  "guests": {
    "interview": {
      "input": {
        "email": "Email",
        "first_name": "First Name",
        "last_name": "Last Name",
        "new_recording": "New Recording",
        "phone_number": "Phone Number",
        "record_now": "Record Now",
        "start_camera": "Start Camera",
        "stop_recording": "Stop Recording",
        "take_picture": "Take a picture"
      },
      "notes": {
        "video_limit": "The maximum video response length is 1 minute."
      },
      "show": {
        "about": "About"
      },
      "success": {
        "answers_message": "Thank you for submitting your responses. We have received your application.",
        "title": "Thank you"
      }
    }
  },
  "helpers": {
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "integration": {
    "facebook": {
      "add_image": "Add Image",
      "apply": "Apply",
      "change_image": "Change Image",
      "save": "Save",
      "select_page_helper": "Linking Facebook page(s) means anyone who chats to your bot can see this campaign. For this campaign not to appear on the chatbot, leave this field empty.\nBelow you can see all the messenger interview links to direct candidates directly to the chatbot interview, this is available even if the facebook page is not linked to this campaign (indicated by the lock icon).",
      "view_job_description": "View Job Description"
    },
    "google": {
      "google_job": "Google Jobs (beta)",
      "job_par": {
        "best_practice": "best_practices",
        "first": "Jobs that are listed on Google will appear directly in the Google search results.",
        "head": "Enable Google indexing of the Landing Page",
        "help_center": "our help center",
        "second": "Applicants that click on these job listings are forwarded to the Talkpush Job Landing Page, where they can choose to apply and immediately complete the screening questions. You can learn more about it in",
        "third": "If your job does not appear in the Google Job posting please make sure you are following those"
      }
    },
    "indeed": {
      "paragraphs": {
        "par_3": "Requires job title, country, region, and long description to be filled out."
      }
    },
    "landing": {
      "copy": "Copy",
      "first": "Landing Page URL",
      "save": "Save"
    },
    "tecoloco": {
      "job_par": {
        "first": "Jobs that are listed in Tecoloco will appear in the Tecoloco feed.",
        "head": "Advertise the job opening on Tecoloco Jobs",
        "help_center": "our help center",
        "second": "Candidates who apply to these job listings are forwarded to the Talkpush Job Landing Page, where they can apply and immediately complete the screening questions. You can learn more about it in"
      },
      "tecoloco_jobs": "Tecoloco Jobs"
    }
  },
  "job_landing_page": {
    "application_invalid": "Invalid application"
  },
  "jobs": {
    "salary_types": {
      "annually": "Annually",
      "biweekly": "Biweekly",
      "daily": "Daily",
      "hourly": "Hourly",
      "monthly": "Monthly",
      "one-time": "One-time",
      "weekly": "Weekly"
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Billion",
          "million": "Million",
          "quadrillion": "Quadrillion",
          "thousand": "Thousand",
          "trillion": "Trillion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "privacy_policy_url": "https://talkpush.com/privacy/",
  "setup_questions": {
    "onboarding_title": "Onboarding Questions",
    "question_types": {
      "audio": "Audio",
      "text": "Text"
    },
    "update": "Update"
  },
  "time": {
    "am": "AM",
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "datemonthyeartime": "%d %b %Y %I:%M %p",
      "datetime": "%b %d, %Y %I:%M %p",
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M",
      "timedate": "%I:%M %p %d %b, %Y"
    },
    "minute": "1 minute",
    "minutes": "%{minutes} minutes",
    "pm": "PM",
    "second": "1 second",
    "seconds": "%{seconds} seconds",
    "time_left": "Time Left: %{minutes} %{seconds}"
  }
});

window.t = I18n.t.bind(I18n);
window.l = I18n.l.bind(I18n);
I18n.locale = document.documentElement.lang;
